import { RoomModalContent } from "@/domains/common";
import { useDesignMaxTheme, useModal } from "@/packages";
import { FONT, RADIUS } from "@/styles";
import { Box, Center } from "@chakra-ui/react";
import { type ThumbnailProps } from "./thumbnail.type";

export const Thumbnail = ({ amountOfImgs, imgUrl, isAvailableBook, roomIdx, roomName }: ThumbnailProps) => {
    const { setModalContent, openModal, setIconName } = useModal();
    const { COLORS } = useDesignMaxTheme();

    const handleModal = () => {
        setModalContent(<RoomModalContent roomIdx={roomIdx} roomName={roomName} />);
        setIconName("close");
        openModal();
    };

    return (
        <Box
            position="relative"
            cursor="pointer"
            _hover={{ opacity: 0.5 }}
            w="100%"
            borderRadius="16px"
            overflow="hidden"
            background={`url(${imgUrl}) no-repeat center/cover`}
            onClick={handleModal}
            _after={{
                content: '""',
                display: "block",
                paddingTop: "100%",
            }}
        >
            {!isAvailableBook && (
                <Center
                    position="absolute"
                    w="100%"
                    h="100%"
                    top="0"
                    left="0"
                    bgColor={COLORS.transparent.b40}
                    color={COLORS.white}
                    sx={{ ...FONT("pretendard", 24, 700) }}
                >
                    Sold Out
                </Center>
            )}
            <Box
                position="absolute"
                top="0"
                left="0"
                color={COLORS.white}
                bgColor={isAvailableBook ? COLORS.positive : COLORS.negative}
                mt="16px"
                p="4px 8px"
                sx={{ ...FONT("pretendard", 12, 500) }}
            >
                {isAvailableBook ? "예약 가능" : "예약 마감"}
            </Box>
            <Center
                position="absolute"
                right="8px"
                bottom="8px"
                color={COLORS.white}
                bgColor={COLORS.transparent.b80}
                p="4px 8px"
                columnGap="4px"
                sx={{ ...FONT("pretendard", 12, 700), ...RADIUS(10), "& span": { fontSize: "14px" } }}
            >
                <span className="material-icons-outlined">photo</span>
                <p>+{amountOfImgs}</p>
            </Center>
        </Box>
    );
};
